import React, { Component } from "react";
import PrismicReact from "prismic-reactjs";
import PropTypes from "prop-types";
import jsonp from "jsonp";
import { Form, Input, Button, Label } from "reactstrap";

class InsiderForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      firstName: "",
      lastName: "",
      message: "",
      disabled: true,
      firstNameError: false,
      lastNameError: false,
      emailError: false,
      textAreaError: false,
      error: false,
      success: false,
      anotherQuestion: false,
      postalCode: "",
      postalCodeError: false,
      confirmCheckbox: false,
      checkboxError: false,
      preferredLanguage: 'English'
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
      error: false,
      success: false
    });
    if (!this.valName(this.state.firstName)) {
      this.setState({
        firstNameError: true,
        error: true
      });   
    }

    if (this.state.firstName && this.valName(this.state.firstName)) {
      this.setState({
        firstNameError: false
      });
    }
    if (this.state.lastName) {
      this.setState({
        lastNameError: false
      });
    }
    if (name === 'postalCode') {
      this.setState({
        postalCode: value
      });
      if (this.valPostalCode(value)) {
        this.setState({
          postalCodeError: false
        });    
      }
    }
    if (this.state.email && this.valEmail(this.state.email)) {
      this.setState({
        emailError: false
      });
    }
    if (name === 'preferredLanguage') {
      this.setState({
        preferredLanguage: target.value
      });
    }
  }

  handleCheckboxChange(event) {
    this.setState(
      ({ confirmCheckbox }) => (
        {
          confirmCheckbox: !confirmCheckbox
        }
      ), function () {
          if(this.state.confirmCheckbox === true) {
            this.setState({
              disabled: false,
              checkboxError: false
            })
          } else if(this.state.confirmCheckbox === false) {
            this.setState({
              disabled: true,
              checkboxError: true
            })
          }
      },
      {
        error: false,
        succes: false
      }
    );

    // console.log(event.target.checked, 'target checked');
  }

  handleSubmit(event) {
    this.validateEmail(this.state.email, this.state.firstName, this.state.lastName, this.state.postalCode);
    event.preventDefault();
  }

  validateEmail(email, firstName, lastName, postalCode) {
    let formSubmitState;
    // Email RegEx in config/formValidation
    if (this.valName(firstName) && this.valEmail(email) && this.valPostalCode(postalCode) && this.state.confirmCheckbox === true) {
      // const formFields = {
      //   firstName: this.state.firstName,
      //   lastName: this.state.lastName,
      //   email: this.state.email,
      //   postalCode: this.state.postalCode
      // }
      
      // Submit email to Mailchimp
      var sendToMailchimp = email => {
        var mailchimpURL =
          "https://auroramj.us10.list-manage.com/subscribe/post-json?u=" +
          this.props.mailchimpListU +
          "&amp;id=" +
          this.props.mailchimpListId +
          "&subscribe=Subscribe&EMAIL=" +
          email +
          "&FIRSTNAME=" +
          this.state.firstName +
          "&LASTNAME=" + this.state.lastName +
          "&POSTALCODE=" + this.state.postalCode +
          "&LANG=" + this.state.preferredLanguage

        jsonp(
          mailchimpURL,
          {
            param: "c"
          },
          (err, data) => {
            if (data) {
              if (data.result === "error") {
                this.setState({
                  error: true,
                  success: false
                });
                formSubmitState = false;
                this.props.onFormSubmit(formSubmitState);
              } else if (data.result === "success") {
                this.setState({
                  success: true,
                  error: false
                });
                formSubmitState = true;
                this.props.onFormSubmit(formSubmitState);                  
              }
            }
          }
        );
      };
      sendToMailchimp(email);
    } else {
      this.setState({
        error: true,
        success: false
      });
      formSubmitState = false;
      this.props.onFormSubmit(formSubmitState);

      if (!this.state.firstName) {
        this.setState({
          firstNameError: true
        });
      }
      if (!this.state.lastName) {
        this.setState({
          lastNameError: true
        });
      }
      if (!this.state.postalCode || !this.valPostalCode(this.state.postalCode)) {
        this.setState({
          postalCodeError: true
        });
      }
      if (this.state.postalCode && this.valPostalCode(this.state.postalCode)) {
        this.setState({
          postalCodeError: false
        });
      }
      if (!this.valEmail(this.state.email)) {
        this.setState({
          emailError: true
        });
      }
      if (this.state.confirmCheckbox === false) {
        this.setState({
          checkboxError: true
        });
      }
    }
  }

  postalFilter(postalCode) {
    if (! postalCode) {
        return null;
    }

    postalCode = postalCode.toString().trim();

    var us = new RegExp("^\\d{5}(-{0,1}\\d{4})?$");
    var ca = new RegExp(/([ABCEGHJKLMNPRSTVXY]\d)([ABCEGHJKLMNPRSTVWXYZ]\d){2}/i);

    if (us.test(postalCode.toString())) {
        return postalCode;
    }

    if (ca.test(postalCode.toString().replace(/\W+/g, ''))) {
        return postalCode;
    }
    return null;
  }

  // Validate email
  valEmail(userEmail) {
    let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let isEmailValid = emailRegex.test(userEmail);

    if (!isEmailValid) {
      this.setState({
        emailError: true,
        disabled: true
      });
    } else {
      this.setState({
        emailError: false
      });
    }
    return isEmailValid;
  }

  // Validate name
  valName(userName) {
    let nameRegex = /^[a-z ,.'-]+$/i;
    let isNameValid = nameRegex.test(userName);

    if (!isNameValid) {
      this.setState({
        nameError: true
      });
    } else {
      this.setState({
        nameError: false
      });
    }
    return isNameValid;
  }

  // Validate message
  valPostalCode(value) {
    let isPostalValid;
    if (value && value !== "" && this.postalFilter(value)) {
      isPostalValid = true;
    } else {
      isPostalValid = false;
    }

    if (!isPostalValid) {
      this.setState({
        postalCodeError: true
      });
    } else {
      this.setState({
        postalCodeError: false
      });
    }
    return isPostalValid;
  }

  render() {
    // Format content
    let formContent = this.props.formContent[0];
    let successContent = this.props.successContent[0];

    let formTitle = PrismicReact.RichText.render(formContent.form_title);
    let formSubTitle = PrismicReact.RichText.render(formContent.form_sub_title);
    let formBlurb = PrismicReact.RichText.render(formContent.form_blurb);
   
    let formSuccessTitle = PrismicReact.RichText.render(successContent.form_success_title);
    let formSuccessSubTitle = PrismicReact.RichText.render(successContent.form_success_sub_title);
    let formSuccessBlurb = PrismicReact.RichText.render(successContent.form_success_blurb);
    // let formSuccessCtaText = successContent.form_success_cta;
    // let checkboxLabel = this.props.checkboxLabel;

    if (this.state.success && this.props.downloadLink) {
      window.open(this.props.downloadLink,'_blank');
    }

    return (
      <div className="form-container">
        <div className={`form-copy ${this.state.success && !this.state.anotherQuestion ? "hide-form-copy" : ""}`}>
          {formSubTitle}
          {formTitle}
          {formBlurb}
        </div>
        <Form onSubmit={this.handleSubmit} noValidate className={`insider-form ${this.state.success && !this.state.anotherQuestion ? 'hide-form' : ''}`}>
          <Input
            type="text"
            name="firstName"
            placeholder={this.props.firstNamePlaceholder ? this.props.firstNamePlaceholder : "First Name"}
            value={this.state.firstName}
            onChange={this.handleChange}
            className={`form-fields  ${this.state.firstNameError ? 'name-error-input' : ''}`}
          />
          <div className={`error-message  ${this.state.firstNameError ? 'name-error-message' : ''}`}>
            {this.props.errorMessage}
          </div>
          <Input
            type="text"
            name="lastName"
            placeholder={this.props.lastNamePlaceholder ? this.props.lastNamePlaceholder : "Last Name"}
            value={this.state.lastName}
            onChange={this.handleChange}
            className={`form-fields  ${this.state.lastNameError ? 'name-error-input' : ''}`}
          />
          <div className={`error-message  ${this.state.lastNameError ? 'name-error-message' : ''}`}>
            {this.props.errorMessage}
          </div>
          <Input
            type="email"
            name="email"
            placeholder={this.props.emailPlaceholder ? this.props.emailPlaceholder : "Email"}
            value={this.state.email}
            onChange={this.handleChange}
            className={`form-fields  ${this.state.emailError ? 'email-error-input' : ''}`}
          />
          <div className={`error-message ${this.state.emailError ? 'email-error-message' : ''}`}>
            {this.props.errorMessage}
          </div>
          <Input 
            type="text" 
            name="postalCode" 
            id="postalCode" 
            placeholder={this.props.postalCodePlaceholder ? this.props.postalCodePlaceholder : "Postal code"}
            value={this.state.postalCode}
            onChange={this.handleChange}
            className={`form-fields  ${this.state.postalCodeError ? 'message-error-input' : ''}`}
          />
          <div className={`error-message ${this.state.postalCodeError ? 'name-error-message' : ''}`}>
            {this.props.errorMessage}
          </div>
          <Label className="small-label" for="preferredLanguage">{this.props.languageLabel ? this.props.languageLabel : "Please select your preferred language for the Insider’s Guide and future emails:"}</Label>
          <fieldset id="preferredLanguage" className="preferred-language radio-button-group">
            <input type="radio" value="English" id="eng-lang" name="preferredLanguage" onClick={this.handleChange} defaultChecked />
            <Label check for="eng-lang">
              {this.props.englishLabel ? this.props.englishLabel : "English"}
            </Label>    
            <input type="radio" value="French" id="fr-lang" name="preferredLanguage" onClick={this.handleChange} />
            <Label check for="fr-lang">
              {this.props.frenchLabel ? this.props.frenchLabel : "French"}
            </Label>    
          </fieldset>
          <div className="custom-checkbox">
            <Input
              type="checkbox"
              value={this.state.confirmCheckbox}
              name="confirmCheckbox"
              id="confirm-checkbox"
              onChange={this.handleCheckboxChange}
              className="checkbox-input"
            />{" "}
            <Label check for="confirm-checkbox">
              {this.props.checkboxLabel}
            </Label>
          </div>
          <div className={`error-message ${this.state.checkboxError ? 'email-error-message' : ''}`}>
            {this.props.errorMessage}
          </div>
          <Button
            type="submit"
            className="newsletter-button"
          >
            {this.props.subscribeBtnText ? this.props.subscribeBtnText : "Subscribe"}

          </Button>
        </Form>
        <div className={`form-success-content ${this.state.success ? 'show-form-success' : ''}`}>
          <div className="form-success-title-wrap">
            {formSuccessTitle}
          </div>
          {formSuccessSubTitle}
          <br />
          <div className="download-blurb">
            {formSuccessBlurb}
            <a
              href={this.props.downloadLink ? this.props.downloadLink : ""}
              className="download-link"
              // disabled={this.state.disabled}
            >
              {this.props.downloadText ? this.props.downloadText : "Get it here"}
            </a>
          </div>
        </div>
      </div>
    );
  }
}

InsiderForm.propTypes = {
  sectionContent: PropTypes.object,
  linkResolver: PropTypes.func
};

export default InsiderForm;






// WEBPACK FOOTER //
// ./src/components/InsiderForm.js